<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tp">Edward Abbey</h1>
<h1 class="tp1">BESTSELLERS</h1>
<p class="tp"><em>Fire on the Mountain<br/>The Monkey Wrench Gang<br/>Hayduke Lives!</em><br/><br/></p>
<p class="tp1"><img alt="" src="OEBPS/images/logo.png"/><br/>New York, 2018</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?1552ecf1